export default __webpack_public_path__ + "media/images/icons/icon-arrow-back-2bfa169f4b8594fd02e56a37c1b47ef9.svg";